export const DASHBOARD_DRILLDOWN_WRAPPER_HEADER_MARGIN_TOP = 16;
